import { StyleSheet, Dimensions, Platform } from 'react-native';

import cardShadow from '../../../../Common/Styles/cardShadow';

const screenWidth = Dimensions.get('window').width;
export default StyleSheet.create({
  containerStyle: {
    marginTop: Platform.OS === 'ios' ? 28 : 17,
  },
  cardContainerStyle: theme => ({
    paddingVertical: 18,
    paddingHorizontal: 16,
    marginBottom: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    ...cardShadow,
  }),
  marginBottom: marginBottom => ({
    marginBottom,
  }),
  marginTop: marginTop => ({
    marginTop,
  }),
  divider: (theme, rest) => ({
    height: 1,
    width: '100%',
    marginTop: 18,
    marginBottom: 29.2,
    backgroundColor: theme.colors.borderColorEight,
    ...rest,
  }),
  firstLine: {
    height: 13,
  },
  secondLine: {
    height: 13,
    marginBottom: 7,
    width: 400,
  },
  thirdLine: {
    height: 13,
    width: 110,
  },
  headerFirstLine: {
    marginBottom: 26,
  },
  lastLine: {
    width: 86,
    height: 13,
    marginLeft: screenWidth / 2 - 60,
  },
  firstCardCircle: {
    width: 33,
    height: 33,
    borderRadius: 28,
    marginRight: 18,
  },
  firstCardLine: {
    marginTop: 7,
    width: '100%',
    height: 12,
  },
  firstCardFirstLine: {
    width: '95%',
    height: 12.5,
  },
  firstCardSecondLine: {
    width: '95%',
    height: 12.5,
    marginTop: 10,
  },
  secondCardLine: (width = '100%') => ({
    marginTop: 7,
    width: width,
    height: 12,
  }),
  headerContainer: {
    marginBottom: 21,
  },
});
